module.exports = __webpack_public_path__ + "static/media/48360582_2308774105864434_8940439193625034752_o-thumb.eb72fbc3.jpg";